// Import the functions you need from the SDKs you need
import { getAuth } from "@firebase/auth";
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

// Firebase web config is public by design (access is enforced by security rules).
// Env vars override it, but the build must not break when no .env is present.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBeLgWZfS7qNhMcQnBDKD8hfxRERyJjLF8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "dobedosoft.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "dobedosoft",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "dobedosoft.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "672844912286",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:672844912286:web:e6c512c0d58b204e964d8f",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-NCHXK0B8FB",
};

// Initialize Firebase
const Firebase = initializeApp(firebaseConfig);
// const analytics = getAnalytics(Firebase);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(Firebase);
export const fireStore = getFirestore(Firebase);
// export const storage = Firebase.storage();
export default Firebase;
